import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'ShopTheSetLazy',
        path: () => path.join(__dirname, './ShopTheSet'),
        resolve: () => require.resolveWeak('./ShopTheSet'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "ShopTheSetLazy" */ './ShopTheSet')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
